import React from 'react';


class MapSvg extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		}
		
	}
		
	getName(id) {
		let stateName = undefined;
		if(this.props.hasOwnProperty("data")) {
			stateName = this.props.data.states.dict[id];
		}
		return stateName
	}

	getColor(id) {
		// const districts = ["me-1","me-2","ne-1","ne-2","ne-3"];
		let clsNme = "neutral"
		let intensity = 3
		let stateName = this.getName(id);

		if(this.props.data.states.o.hasOwnProperty(stateName) && this.props.data.states.o[stateName].candidates.a.length>0) {
			if(this.props.data.states.o[stateName].candidates.a[0].hasOwnProperty("party")) {
				if(this.props.data.states.o[stateName].candidates.a[0].votes*1+this.props.data.states.o[stateName].candidates.a[0].percent*1+this.props.data.states.o[stateName].candidates.a[0].electors*1>0) {
					clsNme = this.props.data.states.o[stateName].candidates.a[0].party;
					if(this.props.data.states.o[stateName].candidates.a[0].party==="Republican Party") {
						clsNme = "R"
					}					
					else if(this.props.data.states.o[stateName].candidates.a[0].party==="Democratic Party") {
						clsNme = "D"
					}					
					else {
						clsNme = "Others"
					}
				}
			}
			if(this.props.data.states.o[stateName].candidates.a[0].hasOwnProperty("percent")) {
				if(!isNaN(this.props.data.states.o[stateName].candidates.a[0].percent) && this.props.data.states.o[stateName].candidates.a[0].percent>0) {
					intensity = Math.round(this.props.data.states.o[stateName].candidates.a[0].percent/100*5);
				}
			}
		}
		return clsNme+" i-"+intensity;
	}

	getColorPolls(id) {
		let clsNme = "tossup"
		let stateName = this.getName(id);
		clsNme = this.props.data.states.o[stateName].polls;
		return clsNme;
	}

	componentDidMount () {
		this.colorAllStates()
		this.setEvents();
	}

	componentDidUpdate() {
		this.colorAllStates()
	}

	setEvents() {
		this.props.data.states.a.map((v,k) => {
			const state = v;
			if(document.getElementById(state.id,state.id)!==null) {
				let internalId = this.getName(state.id)
				let elmnt = document.getElementById(state.id);
				elmnt.addEventListener('mouseover', 
					()=>this.props.showTooltip(internalId) 	
				);				
				elmnt.addEventListener('mouseout', 
					()=>this.props.hideTooltip(internalId) 	
				);
				document.getElementById(state.id).setAttribute("data-tip",'');
				document.getElementById(state.id).setAttribute("data-for",'global');
			}
			return false;
		})
	}

	colorAllStates() {
		this.props.data.states.a.map((v,k) => {
			const state = v;
			if(document.getElementById(state.id,state.id)!==null) {
				if(this.props.show==="results") {
					document.getElementById(state.id).setAttribute("class",'stateGroup '+this.getColor(state.id));
				}
				else {
					document.getElementById(state.id).setAttribute("class",'stateGroup '+this.getColorPolls(state.id));
				}
			}
			return false;
		})
	}

	render() {
		return(

<svg version="1.1" id="usmap" x="0px" y="0px" viewBox="0 0 1625 1020">
<g id="usmap">
	<g id="wa">
		<polygon className="st0" points="207,363.5 207,290.4 143.7,253.8 80.4,290.4 80.4,363.5 143.7,400.1 		"/>
		<text transform="matrix(1 0 0 1 107.3334 339.6802)">WA</text>
	</g>
	<g id="or">
		<polygon className="st0" points="207,607.2 207,534.1 143.7,497.5 80.4,534.1 80.4,607.2 143.7,643.8 		"/>
		<text transform="matrix(1 0 0 1 111.3162 583.3907)">OR</text>
	</g>
	<g id="ca">
		<polygon className="st0" points="277.4,729 277.4,655.9 214.1,619.3 150.7,655.9 150.7,729 214.1,765.6 		"/>
		<text transform="matrix(1 0 0 1 188.6636 705.1749)">CA</text>
	</g>
	<g id="id">
		<polygon className="st0" points="277.4,485.2 277.4,412.1 214.1,375.5 150.7,412.1 150.7,485.2 214.1,521.8 		"/>
		<text transform="matrix(1 0 0 1 196.1795 461.3887)">ID</text>
	</g>
	<g id="wy">
		<polygon className="st0" points="418.1,485.2 418.1,412.1 354.8,375.5 291.5,412.1 291.5,485.2 354.8,521.8 		"/>
		<text transform="matrix(1 0 0 1 320.4226 461.3887)">WY</text>
	</g>
	<g id="sd">
		<polygon className="st0" points="558.8,485.6 558.8,412.5 495.5,375.9 432.2,412.5 432.2,485.6 495.5,522.1 		"/>
		<text transform="matrix(1 0 0 1 470.0963 461.7576)">SD</text>
	</g>
	<g id="az">
		<polygon className="st0" points="488.5,851.1 488.5,777.9 425.2,741.4 361.8,777.9 361.8,851.1 425.2,887.6 		"/>
		<text transform="matrix(1 0 0 1 399.7705 827.252)">AZ</text>
	</g>
	<g id="nm">
		<polygon className="st0" points="558.8,729.2 558.8,656.1 495.5,619.5 432.2,656.1 432.2,729.2 495.5,765.8 		"/>
		<text transform="matrix(1 0 0 1 462.6493 705.3925)">NM</text>
	</g>
	<g id="mt">
		<polygon className="st0" points="347.7,363.4 347.7,290.3 284.4,253.7 221.1,290.3 221.1,363.4 284.4,400 		"/>
		<text transform="matrix(1 0 0 1 254.5782 339.5864)">MT</text>
	</g>
	<g id="nd">
		<polygon className="st0" points="488.5,363.5 488.5,290.4 425.1,253.8 361.8,290.4 361.8,363.5 425.1,400.1 		"/>
		<text transform="matrix(1 0 0 1 395.2714 339.6802)">ND</text>
	</g>
	<g id="la">
		<polygon className="st0" points="769.9,851.1 769.9,777.9 706.6,741.4 643.3,777.9 643.3,851.1 706.6,887.6 		"/>
		<text transform="matrix(1 0 0 1 683.6604 827.252)">LA</text>
	</g>
	<g id="tn">
		<polygon className="st0" points="981,729.2 981,656.1 917.7,619.5 854.3,656.1 854.3,729.2 917.7,765.8 		"/>
		<text transform="matrix(1 0 0 1 890.8116 705.3925)">TN</text>
	</g>
	<g id="ms">
		<polygon className="st0" points="910.6,851.1 910.6,777.9 847.3,741.4 784,777.9 784,851.1 847.3,887.6 		"/>
		<text transform="matrix(1 0 0 1 816.9269 827.252)">MS</text>
	</g>
	<g id="al">
		<polygon className="st0" points="1051.4,851.1 1051.4,777.9 988,741.4 924.7,777.9 924.7,851.1 988,887.6 		"/>
		<text transform="matrix(1 0 0 1 964.0883 827.252)">AL</text>
	</g>
	<g id="ga">
		<polygon className="st0" points="1192.1,851.1 1192.1,777.9 1128.8,741.4 1065.4,777.9 1065.4,851.1 1128.8,887.6 		"/>
		<text transform="matrix(1 0 0 1 1099.8635 827.252)">GA</text>
	</g>
	<g id="wv">
		<polygon className="st0" points="1051.4,607.2 1051.4,534.1 988,497.5 924.7,534.1 924.7,607.2 988,643.8 		"/>
		<text transform="matrix(1 0 0 1 954.6644 583.3904)">WV</text>
	</g>
	<g id="va">
		<polygon className="st0" points="1192.1,607.2 1192.1,534.1 1128.8,497.5 1065.4,534.1 1065.4,607.2 1128.8,643.8 		"/>
		<text transform="matrix(1 0 0 1 1100.8339 583.3904)">VA</text>
	</g>
	<g id="nc">
		<polygon className="st0" points="1121.7,729.2 1121.7,656.1 1058.4,619.5 995.1,656.1 995.1,729.2 1058.4,765.8 		"/>
		<text transform="matrix(1 0 0 1 1029.5181 705.3925)">NC</text>
	</g>
	<g id="sc">
		<polygon className="st0" points="1262.4,729.2 1262.4,656.1 1199.1,619.5 1135.8,656.1 1135.8,729.2 1199.1,765.8 		"/>
		<text transform="matrix(1 0 0 1 1172.7235 705.3925)">SC</text>
	</g>
	<g id="fl">
		<polygon className="st0" points="1121.7,973 1121.7,899.9 1058.4,863.3 995.1,899.9 995.1,973 1058.4,1009.6 		"/>
		<text transform="matrix(1 0 0 1 1036.9902 949.1786)">FL</text>
	</g>
	<g id="dc">
		<polygon className="st0" points="1403.2,729.2 1403.2,656 1339.8,619.5 1276.5,656 1276.5,729.2 1339.8,765.7 		"/>
		<text transform="matrix(1 0 0 1 1310.9622 705.3353)">DC</text>
	</g>
	<g id="pa">
		<polygon className="st0" points="1262.4,485.6 1262.4,412.5 1199.1,375.9 1135.8,412.5 1135.8,485.6 1199.1,522.1 		"/>
		<text transform="matrix(1 0 0 1 1170.2021 461.7576)">PA</text>
	</g>
	<g id="md">
		<polygon className="st0" points="1332.8,607.3 1332.8,534.2 1269.5,497.6 1206.1,534.2 1206.1,607.3 1269.5,643.8 		"/>
		<text transform="matrix(1 0 0 1 1236.6195 583.4659)">MD</text>
	</g>
	<g id="de">
		<polygon className="st0" points="1473.5,607.3 1473.5,534.2 1410.2,497.6 1346.9,534.2 1346.9,607.3 1410.2,643.8 		"/>
		<text transform="matrix(1 0 0 1 1382.8187 583.4659)">DE</text>
	</g>
	<g id="nj">
		<polygon className="st0" points="1403.2,485.2 1403.2,412.1 1339.8,375.5 1276.5,412.1 1276.5,485.2 1339.8,521.8 		"/>
		<text transform="matrix(1 0 0 1 1315.9633 461.3887)">NJ</text>
	</g>
	<g id="ny">
		<polygon className="st0" points="1332.8,363.4 1332.8,290.2 1269.5,253.7 1206.2,290.2 1206.2,363.4 1269.5,399.9 		"/>
		<text transform="matrix(1 0 0 1 1242.0947 339.5503)">NY</text>
	</g>
	<g id="ct">
		<polygon className="st0" points="1543.9,485.2 1543.9,412.1 1480.6,375.5 1417.2,412.1 1417.2,485.2 1480.6,521.8 		"/>
		<text transform="matrix(1 0 0 1 1452.7051 461.3887)">CT</text>
	</g>
	<g id="ma">
		<polygon className="st0" points="1473.5,363.4 1473.5,290.2 1410.2,253.7 1346.9,290.2 1346.9,363.4 1410.2,399.9 		"/>
		<text transform="matrix(1 0 0 1 1377.8363 339.5503)">MA</text>
	</g>
	<g id="vt">
		<polygon className="st0" points="1403.2,241.6 1403.2,168.5 1339.9,131.9 1276.5,168.5 1276.5,241.6 1339.9,278.2 		"/>
		<text transform="matrix(1 0 0 1 1312.4718 217.7841)">VT</text>
	</g>
	<g id="nh">
		<polygon className="st0" points="1543.9,241.6 1543.9,168.5 1480.6,131.9 1417.2,168.5 1417.2,241.6 1480.6,278.2 		"/>
		<text transform="matrix(1 0 0 1 1451.691 217.7843)">NH</text>
	</g>
	<g id="ri">
		<polygon className="st0" points="1614.3,363.4 1614.3,290.2 1550.9,253.7 1487.6,290.2 1487.6,363.4 1550.9,399.9 		"/>
		<text transform="matrix(1 0 0 1 1530.0619 339.55)">RI</text>
	</g>
	<g id="ok">
		<polygon className="st0" points="629.2,851.1 629.2,777.9 565.9,741.4 502.5,777.9 502.5,851.1 565.9,887.6 		"/>
		<text transform="matrix(1 0 0 1 536.9656 827.2518)">OK</text>
	</g>
	<g id="tx">
		<polygon className="st0" points="699.5,973 699.5,899.9 636.2,863.3 572.9,899.9 572.9,973 636.2,1009.6 		"/>
		<text transform="matrix(1 0 0 1 612.8342 949.1786)">TX</text>
	</g>
	<g id="mn">
		<polygon className="st0" points="629.2,363.5 629.2,290.4 565.9,253.8 502.5,290.4 502.5,363.5 565.9,400.1 		"/>
		<text transform="matrix(1 0 0 1 532.0134 339.6799)">MN</text>
	</g>
	<g id="ar">
		<polygon className="st0" points="840.3,729.2 840.3,656.1 777,619.5 713.6,656.1 713.6,729.2 777,765.8 		"/>
		<text transform="matrix(1 0 0 1 747.5657 705.3925)">AR</text>
	</g>
	<g id="oh">
		<polygon className="st0" points="1121.7,485.2 1121.7,412.1 1058.4,375.5 995.1,412.1 995.1,485.2 1058.4,521.8 		"/>
		<text transform="matrix(1 0 0 1 1026.0115 461.3887)">OH</text>
	</g>
	<g id="nv">
		<polygon className="st0" points="347.7,607.2 347.7,534.1 284.4,497.5 221.1,534.1 221.1,607.2 284.4,643.8 		"/>
		<text transform="matrix(1 0 0 1 257.0278 583.3907)">NV</text>
	</g>
	<g id="ne">
		<polygon className="st0" points="629.2,607.2 629.2,534.1 565.9,497.5 502.5,534.1 502.5,607.2 565.9,643.8 		"/>
		<text transform="matrix(1 0 0 1 525.7542 575.6132)">NE</text>
	</g>
	<g id="ut">
		<polygon className="st0" points="418.1,729.2 418.1,656.1 354.8,619.5 291.5,656.1 291.5,729.2 354.8,765.8 		"/>
		<text transform="matrix(1 0 0 1 327.9301 705.3925)">UT</text>
	</g>
	<g id="co">
		<polygon className="st0" points="488.5,607.3 488.5,534.2 425.1,497.6 361.8,534.2 361.8,607.3 425.1,643.8 		"/>
		<text transform="matrix(1 0 0 1 392.7492 583.4659)">CO</text>
	</g>
	<g id="ky">
		<polygon className="st0" points="910.6,607.2 910.6,534.1 847.3,497.5 784,534.1 784,607.2 847.3,643.8 		"/>
		<text transform="matrix(1 0 0 1 821.3856 583.3904)">KY</text>
	</g>
	<g id="ks">
		<polygon className="st0" points="699.6,729.2 699.6,656.1 636.2,619.5 572.9,656.1 572.9,729.2 636.2,765.8 		"/>
		<text transform="matrix(1 0 0 1 608.3127 705.3925)">KS</text>
	</g>
	<g id="ia">
		<polygon className="st0" points="699.6,485.2 699.6,412.1 636.2,375.5 572.9,412.1 572.9,485.2 636.2,521.8 		"/>
		<text transform="matrix(1 0 0 1 614.8287 461.3884)">IA</text>
	</g>
	<g id="mo">
		<polygon className="st0" points="769.9,607.2 769.9,534.1 706.6,497.5 643.3,534.1 643.3,607.2 706.6,643.8 		"/>
		<text transform="matrix(1 0 0 1 672.2361 583.3907)">MO</text>
	</g>
	<g id="il">
		<polygon className="st0" points="840.3,485.2 840.3,412.1 776.9,375.5 713.6,412.1 713.6,485.2 776.9,521.8 		"/>
		<text transform="matrix(1 0 0 1 760.5194 461.3884)">IL</text>
	</g>
	<g id="wi">
		<polygon className="st0" points="769.9,363.4 769.9,290.3 706.6,253.7 643.3,290.3 643.3,363.4 706.6,400 		"/>
		<text transform="matrix(1 0 0 1 679.7477 339.5862)">WI</text>
	</g>
	<g id="mi">
		<polygon className="st0" points="1051.4,363.5 1051.4,290.4 988,253.8 924.7,290.4 924.7,363.5 988,400.1 		"/>
		<text transform="matrix(1 0 0 1 965.1787 339.6802)">MI</text>
	</g>
	<g id="in">
		<polygon className="st0" points="981,485.2 981,412.1 917.7,375.5 854.3,412.1 854.3,485.2 917.7,521.8 		"/>
		<text transform="matrix(1 0 0 1 897.7971 461.3887)">IN</text>
	</g>
	<g id="me">
		<polygon className="st0" points="1614.3,119.7 1614.3,46.6 1550.9,10 1487.6,46.6 1487.6,119.7 1550.9,156.2 		"/>
		<text transform="matrix(1 0 0 1 1506.4492 93.3578)">ME</text>
	</g>
	<g id="me-1">
		<path className="st0" d="M1614.3,119.7l0-73.1L1579,66.8l-0.1,32.3L1614.3,119.7z"/>
	</g>
	<g id="me-2">
		<path className="st0" d="M1578.9,99.1l-27.9,16.2l-0.1,40.9l63.4-36.5L1578.9,99.1z"/>
	</g>
	<g id="ak">
		<polygon className="st0" points="136.7,119.7 136.7,46.6 73.3,10 10,46.6 10,119.7 73.3,156.2 		"/>
		<text transform="matrix(1 0 0 1 47.7376 95.358)">AK</text>
	</g>
	<g id="hi">
		<polygon className="st0" points="136.7,973.1 136.7,900 73.4,863.4 10,900 10,973.1 73.4,1009.6 		"/>
		<text transform="matrix(1 0 0 1 53.4797 949.2581)">HI</text>
	</g>
	<g id="ne-1">
		<path className="st0" d="M629.2,607.2l0.1-73.1l-35.4,20.3v32.3L629.2,607.2z"/>
	</g>	
	<g id="ne-2">
		<path className="st0" d="M565.9,643.8l63.3-36.6l-35.3-20.5l-28,16.3V643.8z"/>
	</g>
	<g id="ne-3">
		<path className="st0" d="M565.9,602.9l-28.6-16l-34.8,20.3l63.4,36.6V602.9z"/>
	</g>

</g>
</svg>



			

		)

	}

}

export default MapSvg
